import {handleHTTPError} from "../../components/ErrorFactory";
import {RegisterFormModel} from "../../models/forms/RegisterFormModel";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {HTTPError} from "../../models/errors/HTTPError";

export async function registerForm(body: RegisterFormModel) {
    // Input validation

    // Check that the form inputs are not null
    if (
        body.inputs.email.current == null ||
        body.inputs.firstName.current == null ||
        body.inputs.lastName.current == null ||
        body.inputs.password.current == null ||
        body.inputs.passwordConfirm.current == null ||
        body.inputs.accessCode.current == null
    ) {
        body.setBanner(handleHTTPError(406, "One or more inputs is currently empty."))
        return;
    }
    // Check that the turnstile challenge has been attempted
    else if (body.inputs.cfTurnstileToken.current === "null") {
        body.setBanner(handleHTTPError(406, "Captcha challenge has not been attempted."))
        return;
    }
    // Check if the email is valid
    else if (!(body.inputs.email.current.value.includes('@') || body.inputs.email.current.value.includes('.'))) {
        body.setBanner(handleHTTPError(406, "Invalid email address."))
        return;
    }
    // Check a name has been entered
    else if (body.inputs.firstName.current.value.length < 1 || body.inputs.lastName.current.value.length < 1) {
        body.setBanner(handleHTTPError(406, "Invalid first or last name entered."))
        return;
    }
    // Check that the passwords match
    else if (body.inputs.password.current.value !== body.inputs.passwordConfirm.current.value) {
        body.setBanner(handleHTTPError(406, "Passwords do not match."))
        return;
    }

    // Create API interface object
    const api = new ApiDataHelper(body.memory);

    // Register the user
    try {
        await api.Execute('/auth/register', {
            body: JSON.stringify({
                email: body.inputs.email.current.value.trim(), // Removes whitespace
                firstName: body.inputs.firstName.current.value,
                lastName: body.inputs.lastName.current.value,
                password: body.inputs.password.current.value,
                accessCode: body.inputs.accessCode.current.value.trim(), // Removes whitespace
                cfTurnstileToken: body.inputs.cfTurnstileToken.current
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST'
        }, false);

        // Inform the user the request was a success
        body.setBanner(handleHTTPError(200, "A verification email has been sent, please follow the instructions to verify and complete account creation."))
    }
    catch(e) {
        // If the error is a HTTP related exception
        if (e instanceof HTTPError) {
            // If a 403 occurs it means the access code was rejected
            if (e.code === 403) {
                body.setBanner(handleHTTPError(403, "Invalid access code."))
            }
            else {
                body.setBanner(handleHTTPError(e.code, e.message))
            }
        }
        else {
            body.setBanner(handleHTTPError(999, ""))
        }
    }
}